/// <reference path="../../main.js" />
define('viewmodels/configuration/EmailReminderSetup',['knockout', 'plugins/router', 'services/navigation', 'services/logger', 'durandal/system', 'services/appsecurity', 'durandal/app'], function (ko, router, navigation, logger, system, appsecurity, app) {

    var EmailReminderViewModel = {
        activate: activate,
        attached: attached,
        appsecurity: appsecurity,
        ControlsAccess: ko.observable(),
        GetEmailJobs: GetEmailJobs,
        EmailJobs: ko.observableArray(),
        EmailServiceSetting: EmailServiceSetting,
        IsEnabled: ko.observable(true),
        ScheduleEmailJobs: ScheduleEmailJobs,
        ConfigureRecipients: ConfigureRecipients,
        GetServiceStatus: GetServiceStatus,
        SaveServiceStatus: SaveServiceStatus,
        UsersList: ko.observableArray([]),
        ToList: ko.observableArray([]),
        CCList: ko.observableArray([]),
        BCCList: ko.observableArray([]),
        newJobType: ko.observable('Recurring'),
        newStartDate: ko.observable(),
        newEndDate: ko.observable(),
        newFrequency: ko.observable(),
        newFirstOccurence: ko.observable(),
        newFirstOccurenceMinutes: ko.observable(),
        newFirstOccurenceHour: ko.observable(),
        RefreshDatePickers: RefreshDatePickers,
        AddEmailJob: AddEmailJob,
        EmailTemplates: ko.observableArray([]),
        newEMailTemplate: ko.observable(),
        ViewHistory: ViewHistory,
        EmailHistory: ko.observableArray([]),
        DeleteJob: DeleteJob,
        DeleteJobCheck: DeleteJobCheck
    };

   
    return EmailReminderViewModel;

    function activate() {
        try {

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: activate() method in EmailReminderSetup.js';
            logger.logMessage(msg);
        }
    }

    function attached() {
        try {
            if (appsecurity.isConfigurationFreeze() === undefined) {
                appsecurity.GetConfigurationFreezeFlag().then(function () {
                    if (appsecurity.WriteAccess() == true && !appsecurity.isConfigurationFreeze()) {
                        EmailReminderViewModel.ControlsAccess(true);
                    }
                    else {
                        EmailReminderViewModel.ControlsAccess(false);
                    }
                });
            }
            else if (appsecurity.WriteAccess() == true && !appsecurity.isConfigurationFreeze()) {
                EmailReminderViewModel.ControlsAccess(true);
            }
            else {
                EmailReminderViewModel.ControlsAccess(false);
            }
            $('#tblScheduledJob').DataTable();
            $('#tblScheduledJobHistory').dataTable();
            GetServiceStatus();
            GetEmailJobs();
            //GetRecipients();
            GetAllUsers();
            getEmailTemplateDetails();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: attached() method in EmailReminderSetup.js';
            logger.logMessage(msg);
        }
    }

    function GetEmailJobs() {
        try {
            
             $.ajax({
                 url: "/api/Configuration/GetEmailJobs",
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })
                .success(ajaxSuccess)
                .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in GetEmailJobs() method in EmailReminderSetup.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult !== null) {
                    tableObj = $('#tblScheduledJob').DataTable();

                    tableObj.destroy();
                    $('#tblScheduledJob tbody tr').remove();
                    var mappedEmailJobs = $.map(jsonResult, function (result) {
                        return new EmailJobsModel(result);
                    });
                    EmailReminderViewModel.EmailJobs(mappedEmailJobs);
                    $('#tblScheduledJob').dataTable();

                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetEmailJobs() method in EmailReminderSetup.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetEmailJobs() method in EmailReminderSetup.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetEmailJobs() method in EmailReminderSetup.js';
                logger.logMessage(msg);
            }
        }
    }

    function GetServiceStatus() {
        try {

            $.ajax({
                url: "/api/Configuration/GetServiceStatus",
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })
                .success(ajaxSuccess)
                .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in GetServiceStatus() method in EmailReminderSetup.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult !== null) {
                    EmailReminderViewModel.IsEnabled(jsonResult);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetServiceStatus() method in EmailReminderSetup.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetServiceStatus() method in EmailReminderSetup.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetServiceStatus() method in EmailReminderSetup.js';
                logger.logMessage(msg);
            }
        }
    }

    function EmailServiceSetting(data, event) {
        GetServiceStatus()
        $('#ServiceSetting').modal('show');
               
    }
    function SaveServiceStatus() {
        try {
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                //Enter your own api
                url: "/api/Configuration/SetServiceStatus?IsEnabled=" + EmailReminderViewModel.IsEnabled(),
                type: "POST",
                contentType: 'application/json',
                dataType: 'json',
                headers: headers

                
            })
                .success(ajaxSuccessServiceStatus)
                .fail(ajaxFailServiceStatus);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxCall in SaveServiceStatus() method in EmailReminderSetup.js';
            logger.logMessage(msg);
        }
        function ajaxSuccessServiceStatus(jsonResult, status) {
            try {
                if (jsonResult != null && jsonResult != 0) {
                    logger.logSuccess('Setting changes have been saved successfully.', 'Success', system.getModuleId(EmailReminderViewModel), true);
                    GetServiceStatus();
                }
                else {
                    logger.logError('Some error occurred while saving.', 'Error', system.getModuleId(EmailReminderViewModel), true);
                }
            }

            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: ajaxSuccess() method in SaveServiceStatus() method in EmailReminderSetup.js';
                logger.logMessage(msg);
            }
        }
        function ajaxFailServiceStatus(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        });
                }
                else {
                    let msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in SaveServiceStatus() method in EmailReminderSetup.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: ajaxFail() method in SaveServiceStatus() method in EmailReminderSetup.js';
                logger.logMessage(msg);
            }
        }
    }

    function GetAllUsers() {
        try {
            $.ajax({
                url: "/api/Configuration/GetAllUserDetails",
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })
                .success(ajaxSuccess)
                .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in GetAllUsers() method in EmailReminderSetup.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, error) {
            try {
                
                if (jsonResult != null) {
                    var mappedUserDetails = $.map(jsonResult, function (result) {
                        return new UserModel(result);
                    });
                    EmailReminderViewModel.UsersList(mappedUserDetails);
                }
                else
                    logger.logError('An error occurred while fetching User details.', 'Error', system.getModuleId(UrViewModel), true);

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetAllUsers() method in EmailReminderSetup.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {

            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();

                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllUsers() method in EmailReminderSetup.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllUsers() method in EmailReminderSetup.js';
                logger.logMessage(msg);
            }
        };
    }

    //function GetRecipients() {
    //    try {

    //        $.ajax({
    //            url: "/api/Configuration/GetRecipients",
    //            type: "GET",
    //            headers: appsecurity.getSecurityHeaders()
    //        })
    //            .success(ajaxSuccess)
    //            .fail(ajaxFail);
    //    }
    //    catch (e) {
    //        var msg = 'Exception: ' + e + ' | Source: ajax call in GetRecipients() method in EmailReminderSetup.js';
    //        logger.logMessage(msg);
    //    }

    //    function ajaxSuccess(jsonResult, status) {
    //        try {
    //            if (jsonResult !== null) {
    //                if (jsonResult.ToList !== null) {
    //                    var mappedToList = $.map(jsonResult.ToList, function (result) {
    //                        EmailReminderViewModel.ToList.push(result.UserId);
    //                    });
    //                    //EmailReminderViewModel.ToList(mappedToList);
    //                }
    //                if (jsonResult.CCList !== null) {
    //                    var mappedCCList = $.map(jsonResult.CCList, function (result) {
    //                        EmailReminderViewModel.CCList.push(result.UserId);
    //                    });
    //                    //EmailReminderViewModel.CCList(mappedCCList);
    //                }
    //                if (jsonResult.BCCList !== null) {
    //                    var mappedBCCList = $.map(jsonResult.BCCList, function (result) {
    //                        EmailReminderViewModel.BCCList.push(result.UserId);
    //                    });
    //                    //EmailReminderViewModel.BCCList(mappedBCCList);
    //                }
    //            }
    //        }
    //        catch (e) {
    //            var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetRecipients() method in EmailReminderSetup.js';
    //            logger.logMessage(msg);
    //        }
    //    }

    //    function ajaxFail(error, status) {
    //        try {
    //            if (error.status == 401) {
    //                app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
    //                    .then(function (option) {
    //                        if (option == "OK")
    //                            navigation.unauthorized();
    //                    })
    //            }
    //            else {
    //                var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetRecipients() method in EmailReminderSetup.js';
    //                logger.logMessage(msg);
    //            }
    //        }
    //        catch (e) {
    //            var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetRecipients() method in EmailReminderSetup.js';
    //            logger.logMessage(msg);
    //        }
    //    }
    //}

    //function SetRecipients() {
    //    try {
    //        var ToList = $.map(EmailReminderViewModel.ToList(), function (result) {
    //            return { UserId: result };
    //        });
    //        var csrfToken = $("input[name='__RequestVerificationToken']").val();
    //        var headers = appsecurity.getSecurityHeaders();
    //        headers.__RequestVerificationToken = csrfToken;
    //        $.ajax({
    //            //Enter your own api
    //            url: "/api/Configuration/SetRecipients",
    //            type: "POST",
    //            headers: headers,
    //            data: {
    //                ToList: ToList,
    //                CCList: $.map(EmailReminderViewModel.CCList(), function (result) {
    //                    return { UserId: result };
    //                }),
    //                BCCList: $.map(EmailReminderViewModel.BCCList(), function (result) {
    //                    return { UserId: result };
    //                }),

    //            }

    //        })
    //            .success(ajaxSuccessSetRecipients)
    //            .fail(ajaxFailSetRecipients);
    //    }
    //    catch (e) {
    //        var msg = 'Exception: ' + e + ' | Source: ajaxCall in SetRecipients() method in EmailReminderSetup.js';
    //        logger.logMessage(msg);
    //    }
    //    function ajaxSuccessSetRecipients(jsonResult, status) {
    //        try {
    //            if (jsonResult != null && jsonResult != 0) {
    //                logger.logSuccess('Recipients have been saved successfully.', 'Success', system.getModuleId(EmailReminderViewModel), true);
    //                //GetRecipients();
    //            }
    //            else {
    //                logger.logError('Some error occurred while saving.', 'Error', system.getModuleId(EmailReminderViewModel), true);
    //            }
    //        }

    //        catch (e) {
    //            let msg = 'Exception: ' + e + ' | Source: ajaxSuccess() method in SetRecipients() method in EmailReminderSetup.js';
    //            logger.logMessage(msg);
    //        }
    //    }
    //    function ajaxFailSetRecipients(error, status) {
    //        try {
    //            if (error.status == 401) {
    //                app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
    //                    .then(function (option) {
    //                        if (option == "OK")
    //                            navigation.unauthorized();
    //                    });
    //            }
    //            else {
    //                let msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in SetRecipients() method in EmailReminderSetup.js';
    //                logger.logMessage(msg);
    //            }
    //        }
    //        catch (e) {
    //            let msg = 'Exception: ' + e + ' | Source: ajaxFail() method in SetRecipients() method in EmailReminderSetup.js';
    //            logger.logMessage(msg);
    //        }
    //    }
    //}

    function ConfigureRecipients(data, event) {
        $('#frmConfigureRecipients').modal('show');
        $('#selectToList').multiselect();
        $('#selectToList').multiselect('refresh');
        $('#selectCCList').multiselect();
        $('#selectCCList').multiselect('refresh');
        $('#selectBCCList').multiselect();
        $('#selectBCCList').multiselect('refresh');
    }
    function RefreshDatePickers(data, event) {
        try {
            $('#StartDate').datepicker({ dateFormat: 'MM dd yy', changeMonth: true, changeYear: true, minDate: 0 });
            $('#EndDate').datepicker({ dateFormat: 'MM dd yy', changeMonth: true, changeYear: true, minDate: 0});
            $('#firstOccurence').datepicker({ dateFormat: 'MM dd yy', changeMonth: true, changeYear: true, minDate:0 });

            return true;
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxFail in RefreshDatePickers() method in EmailReminderSetup.js';
            logger.logMessage(msg);
        }
    }
    function ScheduleEmailJobs(data, event) {
        try {
            $('#EmailError').text("");
            $('#EmailError').hide();
            EmailReminderViewModel.newFrequency('');
            EmailReminderViewModel.newEndDate('');
            EmailReminderViewModel.newFirstOccurence('');
            EmailReminderViewModel.newStartDate('');

            $('#frmScheduleEmailJobs').modal('show');
            RefreshDatePickers();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxFail in ScheduleEmailJobs() method in EmailReminderSetup.js';
            logger.logMessage(msg);
        }
    }
    function AddEmailJob() {
        try {
            $('#EmailError').hide();
            if (EmailReminderViewModel.newJobType() === 'Recurring') {
                if (EmailReminderViewModel.newFrequency()< 1) {
                    $('#EmailError').text("Please input valid frequency.Minimum frequency is 1 day.");
                    $('#EmailError').show();
                    return;
                }
                if ((Date.parse(EmailReminderViewModel.newEndDate()) - Date.parse(EmailReminderViewModel.newFirstOccurence())) < 0) {
                    $('#EmailError').text("First occurence cannot be after the durantion end.");
                    $('#EmailError').show();
                    return;
                }
                if ((Date.parse(EmailReminderViewModel.newFirstOccurence()) - Date.parse(EmailReminderViewModel.newStartDate())) < 0) {
                    $('#EmailError').text("First occurence cannot be before the durantion starts.");
                    $('#EmailError').show();
                    return;
                }
                if (!(/^-?\d+$/.test(EmailReminderViewModel.newFrequency()))) {
                    $('#EmailError').text("Please input valid frequency.");
                    $('#EmailError').show();
                    return;
                }
                if (EmailReminderViewModel.newFrequency()%1!==0) {
                    $('#EmailError').text("Please input valid frequency.");
                    $('#EmailError').show();
                    return;
                }
               
            }
            if ((Date.parse(EmailReminderViewModel.newEndDate()) - Date.parse(EmailReminderViewModel.newStartDate())) < 0) {
                $('#EmailError').text("End date cannot be lesser than start date.");
                $('#EmailError').show();
                return;
            }
            var FirstExecutionDate = EmailReminderViewModel.newFirstOccurence() + " " + EmailReminderViewModel.newFirstOccurenceHour() + ":" + EmailReminderViewModel.newFirstOccurenceMinutes() + ":00 GMT";
            var d = new Date();
            var UTCDate = Date.parse(d.toUTCString());//Converting date to UTC time
            if ((Date.parse(FirstExecutionDate) - UTCDate) < 0) {
                $('#EmailError').text("First occurence cannot be in past.");
                $('#EmailError').show();
                return;
            }
            //FirstExecutionDate.setHours(EmailReminderViewModel.newFirstOccurenceHour());
            //FirstExecutionDate.setMinutes(EmailReminderViewModel.newFirstOccurenceMinutes());         
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                //Enter your own api
                url: "/api/Configuration/AddEmailJob",
                type: "POST",
                headers: headers,
                data: {
                    frequency: EmailReminderViewModel.newFrequency(),
                    JobType: EmailReminderViewModel.newJobType(),
                    NextExecution: FirstExecutionDate,
                    DurationStart: EmailReminderViewModel.newStartDate(),
                    DurationEnd: EmailReminderViewModel.newEndDate(),
                    EmailTemplate: EmailReminderViewModel.newEMailTemplate()
                }

            })
                .success(ajaxSuccessAddEmailJob)
                .fail(ajaxFailAddEmailJob);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxCall in AddEmailJob() method in EmailReminderSetup.js';
            logger.logMessage(msg);
        }
        function ajaxSuccessAddEmailJob(jsonResult, status) {
            try {
                if (jsonResult != null && jsonResult > 0) {
                    logger.logSuccess('Email Job has been added successfully.', 'Success', system.getModuleId(EmailReminderViewModel), true);
                    GetEmailJobs();
                }
                else {
                    logger.logError('Some error occurred while saving.', 'Error', system.getModuleId(EmailReminderViewModel), true);
                }
            }

            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: ajaxSuccess() method in AddEmailJob() method in EmailReminderSetup.js';
                logger.logMessage(msg);
            }
        }
        function ajaxFailAddEmailJob(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        });
                }
                else {
                    let msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in AddEmailJob() method in EmailReminderSetup.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: ajaxFail() method in AddEmailJob() method in EmailReminderSetup.js';
                logger.logMessage(msg);
            }
        }
    }

    function getEmailTemplateDetails() {
        try {
            $.ajax({
                url: "/api/Configuration/GetTemplateDetails",
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })
                .success(ajaxSuccess)
                .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: getEmailTemplateDetails() method in EmailReminderSetup.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult.length > 0) {
                    var MappedTemplateDetails = $.map(jsonResult, function (result) {
                        return new TemplateModel(result);
                    });
                    EmailReminderViewModel.EmailTemplates(MappedTemplateDetails);
                }
                
                
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess from getEmailTemplateDetails() method in EmailReminderSetup.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();

                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in getEmailTemplateDetails() method in EmailReminderSetup.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail from getEmailTemplateDetails() method in EmailReminderSetup.js';
                logger.logMessage(msg);
            }
        }

    }
    function ViewHistory(data, event) {
        try {  
            
            $('#frmViewHistory').modal('show');
           
            GetEmailJobHistory(data);
            
           
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxFail in ScheduleEmailJobs() method in EmailReminderSetup.js';
            logger.logMessage(msg);
        }
    }
    function GetEmailJobHistory(data) {
        try {

            $.ajax({
                url: "/api/Configuration/GetEmailJobHistory?JobId=" + data.JobId(),
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })
                .success(ajaxSuccess)
                .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in GetEmailJobHistory() method in EmailReminderSetup.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {
                tableObj = $('#tblScheduledJobHistory').DataTable();
                tableObj.destroy();
                $('#tblScheduledJobHistory tbody tr').remove();
                if (jsonResult !== null) {
                   
                    var MappedEmailHistory = $.map(jsonResult, function (result) {
                        return new EmailHistoryModel(result);
                    });
                    EmailReminderViewModel.EmailHistory(MappedEmailHistory);                    
                    $('#tblScheduledJobHistory').dataTable();
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetEmailJobHistory() method in EmailReminderSetup.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetEmailJobHistory() method in EmailReminderSetup.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetEmailJobHistory() method in EmailReminderSetup.js';
                logger.logMessage(msg);
            }
        }
    }
    function DeleteJobCheck(data) {
        try {
            app.showMessage("This action will delete the Email job.Are you sure you would like to proceed?", "Warning", ["Yes", "No"], true, { buttonClass: "fa fa-check btn btn-primary", primaryButtonClass: "fa fa-check btn btn-success autofocus", popupIcon: 'title-icon col-md-1 fa fa-copy' })
                .then(function (option) {
                    if (option == "yes") {
                        DeleteJob(data);
                    }
                });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxCall in DeleteJobCheck() method in EmailReminderSetup.js';
            logger.logMessage(msg);
        }
    }
    function DeleteJob(data) {
        try {
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                //Enter your own api
                url: "/api/Configuration/DeleteEmailJob?JobId=" + data.JobId(),
                type: "POST",
                contentType: 'application/json',
                dataType: 'json',
                headers: headers


            })
                .success(ajaxSuccessDeleteJob)
                .fail(ajaxFailDeleteJob);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxCall in DeleteJob() method in EmailReminderSetup.js';
            logger.logMessage(msg);
        }
        function ajaxSuccessDeleteJob(jsonResult, status) {
            try {
                if (jsonResult != null && jsonResult >= 0) {
                    logger.logSuccess('Job has been deleted successfully.', 'Success', system.getModuleId(EmailReminderViewModel), true);
                    GetEmailJobs();

                }
                else {
                    logger.logError('Some error occurred while saving.', 'Error', system.getModuleId(EmailReminderViewModel), true);
                }
            }

            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: ajaxSuccess() method in DeleteJob() method in EmailReminderSetup.js';
                logger.logMessage(msg);
            }
        }
        function ajaxFailDeleteJob(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        });
                }
                else {
                    let msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in DeleteJob() method in EmailReminderSetup.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: ajaxFail() method in DeleteJob() method in EmailReminderSetup.js';
                logger.logMessage(msg);
            }
        }
    }

    function EmailJobsModel(item) {
    try {
        var self = this;
        self.JobId = ko.observable(item.JobId);
        self.Creator = ko.observable(item.Creator);
        self.CreationDate = ko.observable(item.CreationDate);
        self.JobType = ko.observable(item.JobType);
        self.PreviousExecution = ko.observable(item.PreviousExecution);
        self.NextExecution = ko.observable(item.NextExecution);
        self.JobStatus = ko.observable(item.JobStatus);
        self.frequency = ko.observable(item.frequency);
        self.EmailTemplateName = ko.observable(item.EmailTemplateName);
    }
    catch (e) {
        var msg = 'Exception: ' + e + ' | Source: EmailJobsModel() method in EmailReminderSetup.js';
        logger.logMessage(msg);
    }
    }
    function UserModel(item) {
        try {
            var self = this;
            self.UserId = ko.observable(item.UserId);
            self.UserName = ko.observable(item.UserName);
            
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: UserModel() method in EmailReminderSetup.js';
            logger.logMessage(msg);
        }
    }
    function TemplateModel(item) {
        try {
            var self = this;
            self.EmailTemplateId = ko.observable($('<div/>').html(item.TemplateId).text());
            self.EmailTemplateName = ko.observable($('<div/>').html(item.TemplateName).text());          
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: TemplateModel() method in EmailReminderSetup.js';
            logger.logMessage(msg);
        }
    }
    function EmailHistoryModel(item) {
        try {
            var self = this;
            self.statusId = ko.observable(item.statusId); 
            self.JobId = ko.observable(item.JobId);               
            self.ExecutionDate = ko.observable(item.ExecutionDate);
            self.JobStatus = ko.observable(item.JobStatus);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: EmailHistoryModel() method in EmailReminderSetup.js';
            logger.logMessage(msg);
        }
    }

    
});
